import { Injector } from '@angular/core'

import { ClassRegistry } from '../'
import { ModelRepositoryAdapter, BaseModel } from '../../'

export class AppInjector {

  public constructor(
    private _injector: Injector,
    private _classRegistry: ClassRegistry<any>
  ) {}

  public get<T>(klass: {new (...args): T}): T {
    return this._injector.get(klass)
  }

  public getByName<T>(className: string): T {
    const klass = this._classRegistry.get(className)
    return this._injector.get(klass) as T
  }

  public getServiceForModel<T extends ModelRepositoryAdapter<BaseModel>>(modelClassName: string): T  {
    const className = `${modelClassName}Service`
    const service = this.getByName<T>(className)
    if (! (service instanceof ModelRepositoryAdapter)) {
      throw new Error(`The service "${className}" is not a valid ModelRepositoryAdapter!`)
    }

    return service
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/helpers/app-injector/app-injector.ts